import { Modal } from "@gemini/ui"
import { useTranslation } from "react-i18next"

import { useImprint } from "../../hooks/useImprint"
import { ImprintContent } from "./ImprintContent"

const DummyComponent = () => <></>

const ImprintModal = () => {
  const { t } = useTranslation()
  const { isOpen, setIsOpen } = useImprint()

  return (
    <Modal
      testId="immonet-imprint-modal"
      trigger={DummyComponent}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title={t("agencyInfo_legalInformation_impressum")}
      isDismissable={true}
      displayMode="fullHeight"
    >
      <ImprintContent />
    </Modal>
  )
}

export default ImprintModal
